import { LoadingSpinner, ThankYou } from '../components';
import { useEffect, useState } from 'react';

export default function StripeRedirect() {
  const [success, setSuccess] = useState(false);
  useEffect(() => {
    const qs = window.location.href.split('?')[1];
    const parts = qs.split('&');
    const isSuccess = parts.find((p) => p.startsWith('success='))?.split('=')[1].toLowerCase().trim() === 'true';
    setSuccess(isSuccess);
    const timeout = isSuccess ? 1000 : 300;
    setTimeout(() => {
      window.close();
    }, timeout);
  }, []);

  return (
    <div className='page'>
      {success ? <ThankYou/> : <LoadingSpinner />}
    </div>
  );
}
